import React from 'react';

import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import ChatActions from 'chat/actions/ChatActions';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import DialogContent from 'components/DialogContent.jsx';
import ErrorActions from 'actions/ErrorActions';
import UserActions from 'user/UserActions';
import jwt from 'lib/jsonwebtoken';
import linkStateWithStores from 'components/mixins/linkStateWithStores';

const LeaveChatView = React.createClass({
  mixins: [
    linkStateWithStores([ChatStore]),
  ],

  statics: {
    onEnter(nextState, replaceWith, callback) {
      AuthActions.jwtTokenSignIn(nextState.params.token);
      UserActions.loadCurrentUser(nextState.params.token)
        .then(() => {
          const payload = jwt.decode(CurrentUser.getToken());
          return ChatActions.loadChat(payload.chat_uuid);
        }, () => {
          ErrorActions.expiredToken();
          replaceWith('/error');
          callback();
        })
        .then(() => {
          callback();
        }, () => {
          replaceWith('/error');
          callback();
        });
    },
  },

  getInitialState() {
    return this.getStateFromStores();
  },

  getStateFromStores() {
    const payload = CurrentUser.getToken() && jwt.decode(CurrentUser.getToken());
    const chat = payload && ChatStore.getChat(payload.chat_uuid);

    if (!chat) {
      return {};
    }

    return { chat };
  },

  handleLeaveButtonClick() {
    ChatActions.leaveChat(this.state.chat);
  },

  renderConfirmation() {
    const title = 'Leave this conversation?';

    const subtext = 'You won’t receive new messages in this conversation.';

    return (
      <DialogContent
        size="xsmall"
        title={title}
        subtext={subtext}
        glyph="caution"
        glyphColor="lava">
        <BoxBody>
          <Button
            onClick={this.handleLeaveButtonClick}
            level="primary">
            Yes, leave this conversation
          </Button>
        </BoxBody>
      </DialogContent>
    );
  },

  renderLeftMessage() {
    const title =
      'You left this conversation. If you’d like to re-join, please ask your teacher to add you ' +
      'back.';
    const subtext = 'You can now close this browser.';

    return (
      <DialogContent
        size="small"
        title={title}
        subtext={subtext}
      />
    );
  },

  render() {
    if (!this.state.chat) {
      return null;
    } else if (this.state.chat.canLeave()) {
      return this.renderConfirmation();
    } else {
      return this.renderLeftMessage();
    }
  },
});

export default LeaveChatView;



// WEBPACK FOOTER //
// ./src/chat/components/LeaveChatView.jsx